import React, { useEffect, Suspense } from "react";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

// store
import { RootState } from "../redux/store";

// utils
import { changeHTMLAttribute } from "../utils";

// Full-screen splash shown while a lazy public page chunk (e.g. Login) loads.
// It paints the Lumiere light auth background over the body so the legacy teal
// `authentication-bg` never flashes through as a "blue empty page" after a hard
// reload — and blends seamlessly into the auth pages, which use the same tone.
const loading = () => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#f1f4f6",
    }}
  >
    <Spinner
      animation="border"
      role="status"
      style={{ width: "2rem", height: "2rem", color: "#b8c0c4" }}
    >
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>
);

interface DefaultLayoutProps {
  layout: {
    layoutType: string;
    layoutWidth: string;
    leftSideBarTheme: string;
    leftSideBarType: string;
    showRightSidebar: boolean;
  };
  children?: any;
}

const DefaultLayout = (props: DefaultLayoutProps) => {
  const { layoutColor } = useSelector((state: RootState) => ({
    layoutColor: state.Layout.layoutColor,
  }));

  useEffect(() => {
    changeHTMLAttribute("data-bs-theme", layoutColor);
  }, [layoutColor]);

  useEffect(() => {
    if (document.body)
      document.body.classList.add(
        "authentication-bg",
        "authentication-bg-pattern"
      );

    return () => {
      if (document.body)
        document.body.classList.remove(
          "authentication-bg",
          "authentication-bg-pattern"
        );
    };
  }, []);

  // get the child view which we would like to render
  const children = props["children"] || null;

  return (
    <>
      <Suspense fallback={loading()}>{children}</Suspense>
    </>
  );
};
export default DefaultLayout;
